import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'

const PlansComparison = () => {
  const { toggleComparisonPlanSidebar } = usePricingContext()

  const handleClick = async () => {
    toggleComparisonPlanSidebar(true)
    track(trackingEvents.billing.openPlansComparison)
  }

  return (
    <>
      <Box onClick={handleClick} cursor="pointer" textAlign="center">
        <Text size="100">
          {i18n.t('pricing_plans.custom_bundles.business_or_enterprise.label')}{' '}
          <Text size="100" color="viridian1200">
            {i18n.t('pricing_plans.custom_bundles.business_or_enterprise.link')}
          </Text>
        </Text>
      </Box>
    </>
  )
}

export default PlansComparison
